export default "__VITE_ASSET__PtV0A4u7__"